import { render, staticRenderFns } from "./SavedButtons.vue?vue&type=template&id=46e23d08&"
import script from "./SavedButtons.vue?vue&type=script&lang=js&"
export * from "./SavedButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports